import type { KeyboardEvent } from 'react'

/**
 * Wat bij de gedeelde `Dialog` hoort maar niet in het component zelf zit (opdracht van 1 november 2026,
 * R-139, R-140): zien waar iets is gebeurd, en Escape bij de dialoog houden.
 *
 * `Dialog.tsx` is met de branch van de opmerkingen gedeeld en blijft daarom zoals hij daar is; wat deze
 * opdracht extra nodig had staat hier.
 */

/**
 * Een element even markeren na een handeling in een dialoog: "hier is het gebeurd". Dezelfde markering
 * als na een sprong vanuit het paneel Bronnen (`formPanels.tsx`, `[data-gemarkeerd='ja']` in
 * `schil.css`): een attribuut op de DOM en niet in het document, zodat het niet bij een medeschrijver of
 * in de undo-geschiedenis komt. Na `ms` gaat het weer weg.
 */
export const HIGHLIGHT_MS = 2000

export function highlight(element: Element | null | undefined, ms: number = HIGHLIGHT_MS): void {
  if (element === null || element === undefined) return
  element.setAttribute('data-gemarkeerd', 'ja')
  setTimeout(() => element.removeAttribute('data-gemarkeerd'), ms)
}

/**
 * Escape in een dialoog die in een zijpaneel staat sluit alleen de dialoog. De dialoog sluit op het
 * `cancel`-event van de browser; de toets zelf loopt in React door naar het paneel eromheen, dat bij
 * Escape ook sluit (`RightPanel`). Op het element rond de dialoog gezet houdt deze functie hem daar.
 */
export function keepEscapeInDialog(event: KeyboardEvent<HTMLElement>): void {
  if (event.key === 'Escape') event.stopPropagation()
}
